import type { ApplicationError } from '@ps-smart-cp/ppfw-client';
import { BusinessCheckError, genMsg, useGuideTab, useLocalizedContents } from '@ps-smart-cp/ppfw-client';
import type { DeleteFunction } from '../repositories';

interface DeleteTarget {
  id: number;
  version: number;
  code: string;
}

function useMstDelete(deleteFunction: DeleteFunction) {
  const { msg } = useLocalizedContents();
  const { setFieldErrors, setInfo, setErrors, resetGuideTab } = useGuideTab();

  const doDelete = async (targets: DeleteTarget[]) => {
    const results = await Promise.all(
      targets.map(async ({ id, version, code }: DeleteTarget) =>
        deleteFunction(id, version)
          .then(() => code)
          .catch((e: ApplicationError) => e),
      ),
    );

    resetGuideTab();
    const success: string[] = [];
    const businessErrors: BusinessCheckError[] = [];
    const otherErrors: ApplicationError[] = [];

    results.forEach((r) => {
      if (typeof r === 'string') {
        success.push(r);
      } else if (r instanceof BusinessCheckError) {
        businessErrors.push(r);
      } else {
        otherErrors.push(r);
      }
    });

    if (success.length !== 0) {
      setInfo([genMsg(msg.ico00005, success.length.toString()) + `(${success.join(', ')})`]);
    }

    setFieldErrors(
      businessErrors.flatMap((e) =>
        e.fieldErrors.map((f) => ({ field: f.fields?.[0] ?? '', message: f.message ?? e.message })),
      ),
    );

    setErrors(otherErrors.map((e) => e.message));
  };

  return { doDelete };
}

export { useMstDelete };
